import { useHistory } from 'react-router'
import { attachProgramOrderIfNeeded, paidCheckoutPath } from 'pages/WeightLossProgram/trail/programCart'
import { usePrepareCart } from './usePrepareCart'

interface FinalizeOptions {
  redirectTo?: string
  shouldClearCart?: boolean
  alsoClearOrderState?: boolean
}

export function useFinalizeCheckout() {
  const history = useHistory()
  const { clearOrderData, setOrderId, lastOrderCreated } = usePrepareCart() as any

  const finalize = async ({ redirectTo, shouldClearCart = true, alsoClearOrderState = true }: FinalizeOptions = {}) => {
    try {
      localStorage.removeItem('@CANNECT:ORDER_CHECKOUT_CART_ID')
    } catch (e) {
      console.error(e)
    }

    try {
      if (shouldClearCart || alsoClearOrderState) {
        setOrderId(null)
        clearOrderData()
      }
    } catch (e) {
      console.error(e)
    }

    await attachProgramOrderIfNeeded(lastOrderCreated)
    const destination = paidCheckoutPath(lastOrderCreated, redirectTo || '')
    if (destination) {
      history.push(destination)
    }
  }

  return { finalize }
}
